import { Button, CardContent, Divider, Drawer, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography, tableCellClasses } from '@mui/material';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import CustomDataGrid from '../DataGrid/DataGrid';
import { useAppDispatch, useAppSelector, } from "../../store/hooks";
import { ApiStatus } from "../../utils/api.types";
import Link from '@mui/material/Link';
import { /* deleteAddress, */ fetchAddresses } from '../../store/addressStore/addressThunk';
import { Box } from '@mui/system';
import { GridActionsCellItem, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { IAddress } from '../../utils/address.types';
import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
import { PermissionsEnum } from "../../utils/auth.types";
import DialogAddressForm from '../DialogAddressForm/DialogAddressForm';
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import styled from '@emotion/styled';
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#fff',
    color: '#9da7b7',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    margin: 0,
    padding: 5,
    fontSize: 13,
    paddingLeft: '15px !important',
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: '#f5f5f5',
    color: 'black',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: 'sticky'
  },
  [`&.${tableCellClasses.body}`]: {
    verticalAlign: 'super',
    fontSize: 14,
    fontWeight: 'normal',
    color: '#292d35',
    padding: 5,
    border: 'none',
    paddingLeft: '15px !important',
    margin: 0
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#fbfbfb',
    // border: '0.5px dashed #9da7b7',
  },
  '&:nth-of-type(odd)': {
    backgroundColor: '#e9ecf1',
    // border: '0.5px dashed #9da7b7',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
  },
}));

interface AccountAddressInfoProps {
  accountId: string;
}

const AccountAddressInfo: FC<AccountAddressInfoProps> = (props) => {
  const dispatch = useAppDispatch();

  const { addresses, status } = useAppSelector(state => state.addresses);
  const { permissions } = useAppSelector(state => state.auth);

  const [open, setOpen] = useState(false);
  const [addressId, setAddress] = useState('');
  const [fetchData, setFetchData] = useState('');

  // const canCreateAccount = permissions?.includes(PermissionsEnum.Account_Create);
  const canUpdateAccount = permissions?.includes(PermissionsEnum.Account_Update);
  // const canViewAccount = permissions?.includes(PermissionsEnum.Account_View);
  // const canDeleteAccount = permissions?.includes(PermissionsEnum.Account_Delete);

  const openAddressForm = (addressId: string) => {
    setAddress(addressId);
    setOpen(true);
  }

  const closeDialog = (isSaved: boolean) => {
    setOpen(false);

    if (isSaved) {
      setFetchData(Math.random().toString());
    }
  }

  /**
   * Fetch all the accounts on Accounts page load.
   */
  useEffect(() => {
    dispatch(fetchAddresses(props.accountId));
  }, [dispatch, fetchData, props]);

  /**
   * Handler for account name click.
   */
  const handleNameClick = useCallback((address: IAddress) => {
    openAddressForm(address._id);
  }, []);

  /**
  * Method to handle delete account.
  */
  // const deleteSelectedAddress = useCallback((item: IAddress) => () => {
  //   // Dispatch action to delete account.
  //   dispatch(deleteAddress(item._id));
  // }, [dispatch]);

  /**
   * Method to handle delete item.
   */
  // const deleteSelected = useCallback((item: IAddress) => () => {
  //   // Dispatch action to delete.
  //   dispatch(deleteAddress(item._id));
  // }, [dispatch]);

  /**
   * Method to handle edit.
   */
  // const editSelected = useCallback((item: IAddress) => () => {

  // }, [dispatch]);

  /**
   * Column defs for account list data grid.
   */
  const columns: GridColDef[] = useMemo(() => [
    {
      field: "type",
      headerName: 'Address Type',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <Typography
          sx={{ cursor: 'pointer', fontWeight: 'bold' }}
          component={Link}
          underline='hover'
          onClick={() => handleNameClick(row)}
        >
          {value}
        </Typography>
      )
    },
    {
      field: "city",
      headerName: 'City',
      type: "string",
      flex: 1
    },
    {
      field: "state",
      headerName: 'State',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <>
          {value?.name || ''}
        </>
      )
    },
    {
      field: "country",
      headerName: 'Country',
      type: "string",
      flex: 1,
      renderCell: ({ row, value }: GridValueGetterParams) => (
        <>
          {value?.name}
        </>
      )
    },

    {
      field: "actions",
      headerName: 'Actions',
      type: "actions",
      flex: 1,
      getActions: (params: GridValueGetterParams) => {
        const editAction = (
          <GridActionsCellItem
            icon={<EditIcon />}
            title="Edit"
            label="Edit"
            sx={{ paddingLeft: "20px", "&:hover": { backgroundColor: 'transparent' }, "&:focus": { backgroundColor: 'transparent' } }}
            onClick={() => handleNameClick(params.row)}
          />
        );

        // const deleteAction = (
        //   <GridActionsCellItem
        //     icon={<DeleteIcon />}
        //     title="Delete"
        //     label="Delete"
        //     onClick={deleteSelectedAddress(params.row)}
        //   />
        // );

        const actions: JSX.Element[] = [];

        // Push edit action if user has update permission.
        if (canUpdateAccount) {
          actions.push(editAction);
        }

        // Push edit action if user has delete permission.
        // if (canDeleteAccount) {
        //   actions.push(deleteAction);
        // }

        return actions;
      }
    }
  ], [
    // deleteSelected,
    // editSelected,
    canUpdateAccount,
    // canDeleteAccount,
    handleNameClick
  ]);

  return (
    <div className={'c-card2'} style={{ padding: 0 }}>
      <Button
        size='small'
        variant="contained"
        style={{
          float: "right",
          marginRight: 10,
          marginTop: 10,
          color: '#488dff',
          backgroundColor: '#fff',
          border: '0.5px solid #488dff',
          height: 25, borderRadius: 7
        }}
        onClick={() => { openAddressForm('') }}
      >Add Address
      </Button>
      <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, marginLeft: 15, marginTop: 10, marginBottom: 10 }}>Addresses</h5>

      {addresses && addresses.length > 0 ?
        <div style={{ marginBottom: 12, marginTop: 5 }}>
          <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell width={235}>Address Type</StyledTableCell>
                <StyledTableCell width={225}>City</StyledTableCell>
                <StyledTableCell width={150}>State</StyledTableCell>
                <StyledTableCell width={150}>Country</StyledTableCell>
                <StyledTableCell width={100}>Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {addresses.map((e: any) =>
                <StyledTableRow key={e._id}>
                  <StyledTableCell>{e.type}</StyledTableCell>
                  <StyledTableCell>{e.city}</StyledTableCell>
                  <StyledTableCell>{e.state?.name}</StyledTableCell>
                  <StyledTableCell>{e.country?.name}</StyledTableCell>
                  <StyledTableCell align='left'>
                    <IconButton
                      onClick={() => handleNameClick(e)}
                      style={{ color: '#488dff', backgroundColor: '#fff', height: 25, width: 25 }}
                      size='small' ><EditIcon style={{ fontSize: 16 }} />
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        // const rows = documentSettings.filter((obj) => obj._id !== e._id);
                        // setDocumentSetting(rows);
                      }}
                      style={{ color: '#c33b3b', backgroundColor: '#fff', height: 25, width: 25, marginLeft: 10 }}
                      size='small' ><DeleteIcon style={{ fontSize: 16 }} />
                    </IconButton>
                  </StyledTableCell>
                  
                  {/* <StyledTableCell>{moment(e.start_date).format("YYYY")} - {moment(e.end_date).format("YYYY")}</StyledTableCell> */}
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </div> :
        <div style={{ height: 200 }}>
          <Divider sx={{ mt: 0.5, mb: 1 }} />
          No Data</div>
      }
      <Drawer
            anchor="right"
            open={open}
          >
            {<DialogAddressForm open={open} addressId={addressId} onClose={closeDialog}></DialogAddressForm>}
          </Drawer>
    </div>
  );
};

export default AccountAddressInfo;
